import { useEffect, useRef } from 'react';

export function useEffectOnce(effect: () => void) {
  /**
   * Also to prevent the function to be run twice due to strict mode
   */
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
